const CategoriesService = require('../../../backend/CategoriesService')

const getCategories = async (puid, uid, expireKey, language) => {
    try {
        return await CategoriesService.getCategories(puid, uid, expireKey, language);
    } catch (err) {
        alert(err);
    }
}

export { getCategories };
